import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ProductCardModule } from 'src/app/shared/shop/product-card/product-card.module';
import { ProductListComponent } from './product-list.component';


@NgModule({
  declarations: [
    ProductListComponent
  ],
  exports: [
    ProductListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ProductCardModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProductListModule {
}
